export const permissionsConstans = {
  CAR_CONSULTAR: "CAR_CONSULTAR",
  CAR_CREAR: "CAR_CREAR",
  CAR_EDITAR: "CAR_EDITAR",
  HV_ACTUALIZAR: "HV_ACTUALIZAR",
  HV_CREAR: "HV_CREAR",
  USU_CONSULTAR: "USU_CONSULTAR",
  PER_CAR_CONSULTAR: "PER_CAR_CONSULTAR",
  PER_CAR_CREAR: "PER_CAR_CREAR",
  REG_CONSULTAR: "REG_CONSULTAR",
  REG_CREAR: "REG_CREAR",
  REQ_VIEWER_CONSULTAR: "REQ_VIEWER_CONSULTAR",

  // 1. Tramitar Requisiciones:
  // 1.1. Crear
  // 1.2 Consultar
  // 1.3  Editar
  // 1.4 Anular
  REQ_CREAR: "REQ_CREAR",
  REQ_CONSULTAR: "REQ_CONSULTAR",
  REQ_EDITAR: "REQ_EDITAR",
  REQ_ANULAR: "REQ_ANULAR",

  // 2. Gestionar Requisiciones:
  //   2.1 Consultar
  //   2.2 Aprobar
  //   2.3 Rechazar
  //   2.4 Cerrar
  //   2.5 Publicar vacante

  REQ_MANAGE_CONSULTAR: "REQ_MANAGE_CONSULTAR",
  REQ_MANAGE_APROBAR: "REQ_MANAGE_APROBAR",
  REQ_MANAGE_RECHAZAR: "REQ_MANAGE_RECHAZAR",
  REQ_MANAGE_CERRAR: "REQ_MANAGE_CERRAR",
  REQ_MANAGE_PUBLICAR: "REQ_MANAGE_PUBLICAR",

  ROL_CONSULTAR: "ROL_CONSULTAR",
  ROL_CREAR: "ROL_CREAR",
  ROL_EDITAR: "ROL_EDITAR",
  VAC_CONSULTAR: "VAC_CONSULTAR",
  VAC_CREAR: "VAC_CREAR",
  FOR_CLA_CON_CREAR: "FOR_CLA_CON_CREAR",
  FOR_CLA_CON_CONSULTAR: "FOR_CLA_CON_CONSULTAR",
  FOR_CLA_CON_EDITAR: "FOR_CLA_CON_EDITAR",

  VAC_PRIV_CONSULTAR: "VAC_PRIV_CONSULTAR",
  VAC_PRIV_CERRAR: "VAC_PRIV_CERRAR",
  VAC_PRIV_VER_POSTULADOS: "VAC_PRIV_VER_POSTULADOS",

  FOR_TIP_CON_CONSULTAR: "FOR_TIP_CON_CONSULTAR",
  FOR_TIP_CON_CREAR: "FOR_TIP_CON_CREAR",
  FOR_TIP_CON_EDITAR: "FOR_TIP_CON_EDITAR",

  CON_CONSULTAR: "CON_CONSULTAR",
  CON_CREAR: "CON_CREAR",
  CON_ANULAR: "CON_ANULAR",
  CON_RENOVAR: "CON_RENOVAR",

  // laboratory
  LAB_CREAR: 'LAB_CREAR',
  LAB_CONSULTAR: 'LAB_CONSULTAR',
  LAB_EDITAR: 'LAB_EDITAR',

  //permisos
  PERM_CREAR:"PERM_CREAR",
  PERM_ANULAR:"PERM_ANULAR",
  PERM_CONSULTAR: "PERM_CONSULTAR",
  PERM_RECHAZAR:"PERM_RECHAZAR",
  PERM_PREAPROBAR:"PERM_PREAPROBAR",


  PERM_MANAGE_APROBAR:"PERM_MANAGE_APROBAR",
  PERM_MANAGE_CONSULTAR: "PERM_MANAGE_CONSULTAR",
  PERM_MANAGE_RECHAZAR:"PERM_MANAGE_RECHAZAR",


  EXAM_MED_CREAR: 'EXAM_MED_CREAR',
  EXAM_MED_CONSULTAR: 'EXAM_MED_CONSULTAR',
  EXAM_MED_EDITAR: 'EXAM_MED_EDITAR',

  //servicio colectivo
  SER_COL_CREAR: 'SER_COL_CREAR',
  SER_COL_CONSULTAR: 'SER_COL_CONSULTAR',

  //entrega dotación
  DOT_CREAR: 'DOT_CREAR',
  DOT_CONSULTAR: 'DOT_CONSULTAR',
  DOT_CANCELAR: 'DOT_CANCELAR',
  DOT_DESCARGAR: 'DOT_DESCARGAR',

  //lactancia
  MAT_LIC_CREAR: 'MAT_LIC_CREAR',
  MAT_LIC_CONSULTAR: 'MAT_LIC_CONSULTAR',
  MAT_LIC_FINALIZAR: 'MAT_LIC_FINALIZAR',
  MAT_LIC_ANULAR: 'MAT_LIC_ANULAR',

  //recomendación
  REF_REC_CREAR: 'REF_REC_CREAR',
  REF_REC_CONSULTAR: 'REF_REC_CONSULTAR',
  REF_REC_FINALIZAR: 'REF_REC_FINALIZAR',
  REF_REC_ANULAR: 'REF_REC_ANULAR'
};
